import { memo } from "react"
import SummaryContainerStyled from "components/Summary/Summary.styled"
import { IMenu } from "interfaces/IMenu"
import CardOption from "components/Summary/SummaryOption/CardOption"
import { GridContainer, FlexContainer } from "theme/common/Grid.styled"
import { IconSpinner } from "theme/common/Icon.styled"

const SummaryOptions = memo(
  ({
    summaryOptions,
    reversasOptions,
    reversasLoading = false,
    contractor = false,
    grid = true,
  }: {
    summaryOptions: IMenu[]
    reversasOptions?: IMenu[]
    reversasLoading?: boolean
    contractor?: boolean
    grid?: boolean
  }) => {
    return (
      <SummaryContainerStyled>
        <p className="title-summary">
          <b>{contractor ? "Selecciona una bandeja" : "Resumen de actividades"}</b>
        </p>
        {grid ? (
          <GridContainer minSize="320px">
            {summaryOptions.map(({ icon, optionCount, path, title, stateLocation }, index) => (
              <CardOption
                index={index}
                key={`${path}-${title}`}
                icon={icon}
                optionCount={optionCount}
                path={path}
                title={title}
                stateLocation={stateLocation}
              />
            ))}
          </GridContainer>
        ) : (
          <FlexContainer>
            {summaryOptions.map(({ icon, optionCount, path, title, stateLocation }, index) => (
              <CardOption
                index={index}
                key={`${path}-${title}`}
                icon={icon}
                optionCount={optionCount}
                path={path}
                title={title}
                stateLocation={stateLocation}
              />
            ))}
          </FlexContainer>
        )}
        {(reversasOptions !== undefined || reversasLoading) && (
          <SummaryContainerStyled>
            <p className="title-summary">
              <b>{"Reversas"}</b>
            </p>
            {reversasLoading ? (
              <div
                style={{
                  padding: "24px",
                  textAlign: "center",
                  color: "#666",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <IconSpinner variant="big" />
                <span>Cargando opciones de reversas...</span>
              </div>
            ) : (
              <>
                {grid ? (
                  <GridContainer minSize="320px">
                    {reversasOptions?.map(({ icon, optionCount, path, title, stateLocation }, index) => (
                      <CardOption
                        index={index}
                        key={`${path}-${title}`}
                        icon={icon}
                        optionCount={optionCount}
                        path={path}
                        title={title}
                        stateLocation={stateLocation}
                      />
                    ))}
                  </GridContainer>
                ) : (
                  <FlexContainer>
                    {reversasOptions?.map(({ icon, optionCount, path, title, stateLocation }, index) => (
                      <CardOption
                        index={index}
                        key={`${path}-${title}`}
                        icon={icon}
                        optionCount={optionCount}
                        path={path}
                        title={title}
                        stateLocation={stateLocation}
                      />
                    ))}
                  </FlexContainer>
                )}
              </>
            )}
          </SummaryContainerStyled>
        )}
      </SummaryContainerStyled>
    )
  },
)

export default SummaryOptions
